function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20.57",
  height: "20.57",
  viewBox: "0 0 20.57 20.57",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M19.95 18.24l-4.54-4.53a8.43 8.43 0 10-1.7 1.7l4.54 4.53a1.2 1.2 0 001.7-1.7zM2.64 8.67a6.01 6.01 0 116.02 6.01 6.01 6.01 0 01-6.01-6.01z",
  strokeWidth: ".5"
})));